import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SvgIconModule } from 'shared/components/svg-icon/svg-icon.module';
import { Ng2SetFocusModule } from 'common/on-event-focus/ng2-set-focus.module';
import { KeyboardShortcutsMenuComponent } from 'components/keyboard-shortcuts-menu/keyboard-shortcuts-menu.component';
import { UiSwitchModule } from 'ngx-ui-switch';
import { ClosingConfirmationService } from 'shared/components/confirmation-modal/confirmation-modal.service';

@NgModule({
  imports: [
    CommonModule,
    SvgIconModule,
    TranslateModule.forChild(),
    Ng2SetFocusModule,
    UiSwitchModule
  ],
  declarations: [
    KeyboardShortcutsMenuComponent
  ],
  providers: [
    ClosingConfirmationService
  ],
  exports: [
    KeyboardShortcutsMenuComponent
  ]
})
export class KeyboardShortcutsMenuModule {}
